export default {
    //main
    'dashcheck': {
        'get': '/dashcheck'
    },
    'bug_report': {
        'post': '/bug-report/',
    },
    //master
    'clients': {
        'data': '/client/data/',
        'task_status': '/client/task_status/',
        'tenancy_integrity_check': '/client/tenancy_integrity_check/',
        'get': '/client/', // create step1
        'client_create_db': '/client/:pk:/client_create_db/', // create step2
        'client_migrate_db': '/client/:pk:/client_migrate_db/', // create step3
        'client_create_client': '/client/:pk:/client_create_client/', // create step4
        'client_sync_presets': '/client/:pk:/client_sync_presets/', // create step5
        'client_create_admin': '/client/:pk:/client_create_admin/', // // create step6

        'client_elastic_sync': '/client/:pk:/client_elastic_sync/', // // create step6

        'client_acl_sync': '/client/:pk:/client_acl_sync/',

        'post': '/client/:pk:/',
        'client_record': '/client/client_record/',
        'logo': '/client/logo/',

        'create_fileshare': '/client/:pk:/create_fileshare/',
        'reset_password': '/client/:pk:/reset_password/',
    },
    //
    'company_type': {
        'get': '/organization/company_type/',
        'post': '/organization/company_type/:pk:/',
        'reorder': '/organization/company_type/reorder/',
    },
    'company_subtypes': {
        'get': '/organization/company_subtypes/',
        'post': '/organization/company_subtypes/:pk:/',
        'reorder': '/organization/company_subtypes/reorder/',
    },
    'sector': {
        'get': '/organization/sector/',
        'post': '/organization/sector/:pk:/',
        'reorder': '/organization/sector/reorder/',
    },
    'sub_sectors': {
        'get': '/organization/sub_sectors/',
        'post': '/organization/sub_sectors/:pk:/',
        'reorder': '/organization/sub_sectors/reorder/',
    },
    'corporate_status': {
        'get': '/organization/corporate_status/',
        'post': '/organization/corporate_status/:pk:/',
        'reorder': '/organization/corporate_status/reorder/',
    },
    'source_type': {
        'get': '/organization/source_type/',
        'post': '/organization/source_type/:pk:/',
        'reorder': '/organization/source_type/reorder/',
    },
    'ownership': {
        'get': '/organization/ownership/',
        'post': '/organization/ownership/:pk:/',
        'reorder': '/organization/ownership/reorder/',
    },
    'trading_status': {
        'get': '/organization/trading_status/',
        'post': '/organization/trading_status/:pk:/',
        'reorder': '/organization/trading_status/reorder/',
    },
    'document_type': {
        'get': '/project/document_type/',
        'post': '/project/document_type/:pk:/',
        'reorder': '/project/document_type/reorder/',
    },
    'project_status': {
        'get': '/project/project_status/',
        'post': '/project/project_status/:pk:/',
        'reorder': '/project/project_status/reorder/',
    },
    'transaction_type': {
        'get': '/transaction/transaction_type/',
        'post': '/transaction/transaction_type/:pk:/',
        'data': '/transaction/transaction_type/data/',
        'reorder': '/transaction/transaction_type/reorder/',
    },
    'project_stage': {
        'get': '/project/project_stage/',
        'reorder': '/project/project_stage/reorder/',
        'post': '/project/project_stage/:pk:/',
    },
    'buyer_stage': {
        'get': '/project/buyer_stage/',
        'reorder': '/project/buyer_stage/reorder/',
        'post': '/project/buyer_stage/:pk:/',
    },
    'currency': {
        'get': '/transaction/currency/',
        'post': '/transaction/currency/:pk:/',
        'reorder': '/transaction/currency/reorder/',
    },
    'user_title': {
        'get': '/user_title/',
        'post': '/user_title/:pk:/',
        'reorder': '/user_title/reorder/',
    },
    'job_title': {
        'get': '/job_title/',
        'post': '/job_title/:pk:/',
        'reorder': '/job_title/reorder/',
    },
    'employee_sector': {
        'get': '/employee_sector/',
        'post': '/employee_sector/:pk:/',
        'reorder': '/employee_sector/reorder/',
    },
    'signature': {
        'generate': '/acl/gen_signed_token/',
    },
    'groups': {
        'get': '/groups/',
        'details': '/groups/:pk:/',
        'get_group_members': '/groups/:pk:/get_group_members/',
        'get_user': '/groups/:pk:/get_user/',
        'add_members': '/groups/:pk:/add_members/',
        'delete_group_member': '/groups/:pk:/delete_group_member/',
        'post': '/groups/:pk:/',
        'save_group_permission': '/groups/save_group_permission/',
        'get_group_permission_set': '/groups/:pk:/get_group_permission_set/',
    },
    'subgroups': {
        'get': '/sub-groups/',
        'post': '/sub-groups/:pk:/',
        'get_users': '/sub-groups/:pk:/get_users/',
        'search_users': '/sub-groups/:pk:/search_users/',
        'add_user': '/sub-groups/:pk:/add_user/',
        'delete_user': '/sub-groups/:pk:/delete_user/',
        'get_groups': '/sub-groups/get_groups/',
        'get_resources': '/sub-groups/get_resources/',
        'change_policy': '/sub-groups/change_policy/',
        'permissions': '/sub-groups/permissions/',
    },
    'teams': {
        'get': '/teams/',
        'post': '/teams/:pk:/',
    },
    'followers': {
        'team_user_search': '/modules/crm/opportunities/followers/team_user_search/',
        'my_followings': '/modules/crm/opportunities/followers/my_followings/',
        'my_followings_post': '/modules/crm/opportunities/followers/:pk:/my_followings/',
    },
    'permissions': {
        'data': '/permissions/data/',
        'get': '/permissions/',
        'post': '/permissions/:pk:/',
        'create_group_policy': '/permissions/create_group_policy/',
    },
    'departments': {
        'get': '/organization/departments/',
        'post': '/organization/departments/:pk:/',
        'reorder': '/organization/departments/reorder/',
    },
    'companies': {
        'data': '/organization/companies/data/',
        'search': '/organization/companies/search/',
        'get': '/organization/companies/',
        'post': '/organization/companies/:pk:/',
        'report_table_data': '/organization/companies/:pk:/report_table_data/',
        'previous_deals': '/organization/companies/:pk:/previous_deals/',
        'logo': '/organization/companies/:pk:/logo/',
        'tear_sheet': '/organization/companies/:pk:/tear_sheet/',
        'private_equity': '/organization/companies/private_equity/',
        'private_equity_deals': '/organization/companies/private_equity_deals/',
        'get_pe_country': '/organization/companies/get_pe_country/',
        'activities': '/organization/companies/:pk:/activities/',
        'schedules': '/organization/companies/:pk:/schedules/',
        'pe_activity_schedule': '/organization/companies/pe_activity_schedule/',
        'pe_activity_update': '/organization/companies/:pk:/pe_activity_update/',
        'private_equity_activity': '/organization/companies/private_equity_activity/',
        'notes': '/organization/companies/:pk:/notes/',
        'update_notes_reply': '/organization/companies/:pk:/update_notes_reply/',
        'notes_remove': '/organization/companies/notes_remove/',
        'get_company_logo': '/organization/companies/get_company_logo/',
        'company_logo_proxy': '/organization/companies/company_logo_proxy/',
        'stock_search': '/organization/stock_search/',
        'stock_list_retrieve': '/organization/stock_list_retrieve/',
        'stock_price': '/organization/stock_price/',
        'stock_add': '/organization/stock_add/',
        'stock_remove': '/organization/stock_remove/',
        'company_finder': '/organization/company_finder/',
        'person_finder': '/organization/person_finder/',
        'get_linkedIn_number': '/organization/get_linkedIn_number/',
        'add_company_to_crm_person': '/organization/companies/add_company_to_crm_person/',
        'person_finder_li': '/organization/person_finder_li/',
        'person_finder_li_rocketreach': '/organization/person_finder_li_rocketreach/',
        'person_lookup_li': '/organization/person_lookup_li/',

        'pe_companies_project': '/organization/companies/pe_companies_project/',

        'uk_company_finder': '/organization/uk_company_finder/',
        'uk_company_profile': '/organization/uk_company_profile/',
        'uk_company_shareholder': '/organization/uk_company_shareholder/',
        'uk_company_finanicals': '/organization/uk_company_finanicals/',
        'cdb_uk_company_finanicals': '/organization/cdb_uk_company_finanicals/',
        'cdb_bulk_uk_company_finanicals': '/organization/cdb_bulk_uk_company_finanicals/',

        'cdb_company_profile': '/organization/cdb_company_profile/',
        'uk_company_shareholder_api': '/organization/uk_company_shareholder_api/',
        'cdb_uk_company_shareholders': '/organization/cdb_uk_company_shareholders/',
        'uk_company_finanicals_api': '/organization/uk_company_finanicals_api/',
        'uk_company_finanicals_shareholder': '/organization/uk_company_finanicals_shareholder/',
        'company_funding_data': '/organization/company_funding_data/',
        'company_mna_acquisition_data': '/organization/company_mna_acquisition_data/',
        'company_employees_data': '/organization/company_employees_data/',
        'company_person_data': '/organization/company_person_data/',
        'company_person_lookup_data': '/organization/company_person_lookup_data/',
        'person_track_job_change': '/organization/person_track_job_change/',
        'get_company_recent_news': '/organization/get_company_recent_news/',
        'get_company_comparables': '/organization/get_company_comparables/',
        'get_company_address': '/organization/get_company_address/',
        'get_company_portfolio': '/organization/get_company_portfolio/',
    },
    'pe_schedule': {
        'get': '/organization/schedules/',
        'post': '/organization/schedules/:pk:/',
    },
    'pe_documents': {
        'get': '/organization/documents/',
        'post': '/organization/documents/:pk:/',
    },
    'pitchbooks': {
        'data': '/organization/pitchbooks/data/',
        'search': '/organization/pitchbooks/search/',
        'get': '/organization/pitchbooks/',
        'companies': '/organization/pitchbooks/:pk:/companies/',
        'edit': '/organization/pitchbooks/:pk:/edit/',
        'reorder': '/organization/pitchbooks/:pk:/reorder/',
        'buyer_description': '/organization/pitchbooks/:pk:/buyer_description/',
        'delete_companies': '/organization/pitchbooks/:pk:/delete_companies/',
        'get_companies': '/organization/pitchbooks/:pk:/get_companies/',
        'import_csv_companies': '/organization/pitchbooks/:pk:/import_csv_companies/',
        'add_to_pitchbook': '/organization/pitchbooks/:pk:/add_to_pitchbook/',
        'post_pitchbook_desc': '/organization/pitchbooks/:pk:/post_description/',
        'post': '/organization/pitchbooks/:pk:/',
        'buyer_report': '/organization/pitchbooks/:pk:/buyer_report/',
    },
    'company_details': {
        'data': '/organization/company_details/data/',
        'get': '/organization/company_details/',
        'post': '/organization/company_details/:pk:/'
    },
    'descriptions': {
        'data': '/organization/descriptions/data/',
        'get': '/organization/descriptions/',
        'post': '/organization/descriptions/:pk:/'
    },
    'office_address': {
        'data': '/organization/office_address/data/',
        'get': '/organization/office_address/',
        'post': '/organization/office_address/:pk:/'
    },
    'mna_transactions': {
        // 'data': '/organization/mna_transactions/data/',
        'get': '/organization/mna_transactions/',
        'post': '/organization/mna_transactions/:pk:/',
        'upload': '/organization/mna_transactions/upload/',
    },
    'contact': {
        'search': '/contact/search/',
        'data': '/contact/data/',
        'people_data': '/contact/people_data/',
        'get': '/contact/',
        'post': '/contact/:pk:/',
    },
    'projects': {
        'get': '/project/projects/',
        'post': '/project/projects/:pk:/',
        'data': '/project/projects/data/',
        'search': '/project/projects/search/',
        'my_projects': '/project/projects/my_projects/',
        'my_projects_data': '/project/projects/my_projects_data/',
        'all_projects': '/project/projects/all_projects/',
        'all_projects_data': '/project/projects/all_projects_data/',
        'projects_global_search': '/project/projects/projects_global_search/',
        'stage_history': '/project/projects/stage_history/',

        'project_details_data': '/project/projects/:pk:/project_details_data/',
        'project_details_fields': '/project/projects/:pk:/project_details_fields/',
        'project_details_buyers': '/project/projects/:pk:/project_details_buyers/',

        'pe_project_details_data': '/project/projects/pe_project_details_data/',
        'pe_company_details_data': '/project/projects/pe_company_details_data/',

        // 'details': '/project/details/:pk:/',
        'distribution_buyers': '/project/projects/:pk:/distribution_buyers/',
        'searches': '/project/projects/:pk:/searches/',
        'actions': '/project/projects/:pk:/actions/',
        'buyer_contacts': '/project/projects/:pk:/buyer_contacts/',
        'buyer_comments': '/project/projects/:pk:/buyer_comments/',
        'primary_contact': '/project/projects/:pk:/primary_contact/',
        'buyer_stage': '/project/projects/buyer_stage/',
        'companies': '/project/projects/get_companies/',
        'projects_companies': '/project/projects/:pk:/projects_companies/',
        'project_buyer_names': '/project/projects/:pk:/project_buyer_names/',
        'project_buyer_data': '/project/projects/:pk:/project_buyer_data/',
        'distribution_companies': '/project/projects/:pk:/distribution_companies/',
        'create_distribution': '/project/projects/:pk:/create_distribution/',
        'distribution_files': '/project/projects/:pk:/distribution_files/',
        'download_distribution_files': '/project/projects/:pk:/download_distribution_files/',
        'process_email_template': '/project/projects/:pk:/process_email_template/',
        'get_distribution_templates': '/project/projects/:pk:/get_distribution_templates/',
        'update_status': '/project/projects/update_status/',
        'update_buyer': '/project/projects/update_buyer/',
        'import_company': '/project/projects/import_company/',
        'delete_company': '/project/projects/delete_company/',
        'save_imported_companies': '/project/projects/save_imported_companies/',
        'project_companies': '/project/projects/project_companies/',
        'project_report_data': '/project/projects/project_report_data/',
        'buyer_report': '/project/projects/buyer_report/',
        'template_upload': '/project/projects/:pk:/template_upload/',
        'delete_document_template': '/project/projects/:pk:/delete_document_template/',
        'delete_distribution_files': '/project/projects/:pk:/delete_distribution_files/',
        'get_project_stages': '/project/projects/get_project_stages/',
        'project_buyer_home': '/project/projects/project_buyer_home/',

        'export_buyers': '/project/projects/:pk:/export_buyers/',
    },
    'filter_setting_folders': {
        'get': '/project/filter_setting_folders/',
        'post': '/project/filter_setting_folders/:pk:/',
    },
    'filter_settings': {
        'get': '/project/filter_settings/',
        'post': '/project/filter_settings/:pk:/',
        'selected': '/project/filter_settings/:pk:/selected/',
        'edit_lock': '/project/filter_settings/:pk:/edit_lock/',
        'share': '/project/filter_settings/:pk:/share/',
        'shared_with_users': '/project/filter_settings/:pk:/shared_with_users/',
        'remove_shared_filter': '/project/filter_settings/:pk:/remove_shared_filter/',
    },
    'filter_email_report_settings': {
        'get': '/project/filter_email_report_settings/',
        'post': '/project/filter_email_report_settings/:pk:/',
    },
    'my_filter_email_reports': {
        'get': '/project/my_filter_email_reports/',
        'post': '/project/my_filter_email_reports/:pk:/',
    },
    'buyer_categories': {
        'reorder': '/project/buyer_categories/reorder/',
    },
    'buyer_ranks': {
        'reorder': '/project/buyer_ranks/reorder/',
    },
    'portfolio_prospections': {
        'get': '/organization/portfolio_prospections/',
        'post': '/organization/portfolio_prospections/:pk:/',
    },
    'current_portfolios': {
        'get': '/organization/current_portfolios/',
        'post': '/organization/current_portfolios/:pk:/',
    },
    'watermark_settings': {
        'get': '/project/watermark_settings/',
        'post': '/project/watermark_settings/:pk:/',
        'project': '/project/watermark_settings/project/',
        'preview': '/project/watermark_settings/preview/',
    },
    'buyer_comments': {
        'get': '/project/buyer_comments/',
        'post': '/project/buyer_comments/:pk:/',
    },
    'buyer_history': {
        // 'get': '/project/buyer_history/',
        'post': '/project/buyer_history/:pk:/',
    },
    'project_buyers': {
        'get': '/project/project_buyers/',
        'post': '/project/project_buyers/:pk:/',
        'primary': '/project/project_buyers/:pk:/primary/',
        'project_buyer_reminder': '/project/project_buyers/:pk:/project_buyer_reminder/',
        'project_buyer_update_reminder': '/project/project_buyers/:pk:/project_buyer_update_reminder/',
        'reorder': '/project/project_buyers/reorder/',
    },
    'invites': {
        'data': '/invites/data/',
        'get': '/invites/',
        'post': '/invites/:pk:/',
        'resend': '/invites/:pk:/resend/',
    },
    'reports': {
        'get': '/report/reports/',
        'post': '/report/reports/:pk:/',
        'update_positions': '/report/reports/update_positions/',
        'slug_daterange': '/report/reports/slug_daterange/',
        'realtime': '/report/reports/realtime/',
        'email_report_settings': '/report/reports/email_report_settings/',
        'email_report_schedules': '/report/reports/email_report_schedules/',

        'project_staffing': '/report/reports/project_staffing/',
        'update_staffing_positions': '/report/reports/update_staffing_positions/',

        'email_report_periodic_data': '/report/reports/email_report_periodic_data/',
    },
    'report_pages': {
        'get': '/report/report_pages/',
        'post': '/report/report_pages/:pk:/',
        'reorder': '/report/report_pages/reorder/',
    },
    'users': {
        'data': '/users/data/',
        'get': '/users/',
        'post': '/users/:pk:/',
        'user_status': '/users/:pk:/user_status/',
        'user_image': '/users/:pk:/user_image/',
        'projects': '/users/:pk:/projects/',
        'get_permission_set': '/users/:pk:/get_permission_set/',
        'save_permission': '/users/:pk:/save_permission/',
        'search': '/users/search/',
        'import_users': '/users/import_users/',
        'direct_create': '/users/direct_create/',
        'my_profile': '/users/my_profile/',
        'user_by_permission': '/permission-users/',
        'change_permission': '/permission-users/:pk:/change_permission/',
        'send_verify_code': '/users/send_verify_code/',
        'check_verify_code': '/users/check_verify_code/',
    },
    'user_by_permission': {
        'get': '/permission-users/',
    },

    //modules_crm
    'pipelines': {
        'get': '/modules/crm/pipelines/',
        'post': '/modules/crm/pipelines/:pk:/',
        'reorder': '/modules/crm/pipelines/reorder/',
    },
    'pipeline_stages': {
        'get': '/modules/crm/pipelines/stages/',
        'post': '/modules/crm/pipelines/stages/:pk:/',
        'reorder': '/modules/crm/pipelines/stages/reorder/',
    },
    'note_titles': {
        'get': '/modules/crm/opportunities/note_titles/',
        'post': '/modules/crm/opportunities/note_titles/:pk:/',
    },
    'opportunity': {
        'get': '/modules/crm/opportunities/',
        'post': '/modules/crm/opportunities/:pk:/',
        'biz_dev_create': '/modules/crm/opportunities/biz_dev_create/',
        'bulk_upload': '/modules/crm/opportunities/bulk_upload/',
        'bulk_create': '/modules/crm/opportunities/bulk_create/',
        'data': '/modules/crm/opportunities/data/',
        'company': '/modules/crm/opportunities/:pk:/company/',
        'contacts': '/modules/crm/opportunities/:pk:/contacts/',
        'projects': '/modules/crm/opportunities/:pk:/projects/',
        // 'activities': '/modules/crm/opportunities/:pk:/activities/',
        // 'schedules': '/modules/crm/opportunities/:pk:/schedules/',
        // 'note_images': '/modules/crm/opportunities/:pk:/note_images/',
        // 'notes': '/modules/crm/opportunities/:pk:/notes/',
        // 'notes_reply': '/modules/crm/opportunities/:pk:/notes_reply/',
        // 'get_notes_reply': '/modules/crm/opportunities/:pk:/get_notes_reply/',
        // 'notes_remove': '/modules/crm/opportunities/notes_remove/',
        'notification_remove': '/modules/crm/opportunities/notification_remove/',
        'update_notes_reply': '/modules/crm/opportunities/:pk:/update_notes_reply/',
        'custom_fields': '/modules/crm/opportunities/custom_fields/',
        'custom_field_options': '/modules/crm/opportunities/custom_field_options/',
        'custom_fields_all': '/modules/crm/opportunities/:pk:/custom_fields_all/',
        'custom_fields_all_v2': '/modules/crm/opportunities/:pk:/custom_fields_all_v2/',
        'form_data': '/modules/crm/opportunities/get_form_data/',
        'get_pipeline_stages': '/modules/crm/opportunities/get_pipeline_stages/',
        'get_fields': '/modules/crm/opportunities/get_field_set/',
        'get_sectioned_field_set': '/modules/crm/opportunities/get_sectioned_field_set/',
        'change_form_view': '/modules/crm/opportunities/change_form_view/',
        'create_custom_field': '/modules/crm/opportunities/create_custom_field/',
        'update_custom_field': '/modules/crm/opportunities/update_custom_field/',
        'remove_custom_field': '/modules/crm/opportunities/remove_custom_field/',
        'update_layout': '/modules/crm/opportunities/update_layout/',
        'all_opportunities': '/modules/crm/opportunities/all_opportunities/',
        'all_opportunities_data': '/modules/crm/opportunities/all_opportunities_data/',
        'form_setting_field': '/modules/crm/opportunities/:pk:/form_setting_field/',
        'opportunity_activity_schedule': '/modules/crm/opportunities/opportunity_activity_schedule/',
        'opportunity_activity_update': '/modules/crm/opportunities/:pk:/opportunity_activity_update/',
        'opportunity_activity_remove_form_home': '/modules/crm/opportunities/:pk:/opportunity_activity_remove_form_home/',
        'lost_reason_create': '/modules/crm/opportunities/:pk:/lost_reason_create/',
        'inactive_reasons': '/modules/crm/opportunities/:pk:/inactive_reasons/',
        'opportunity_tracker': '/modules/crm/opportunities/:pk:/opportunity_tracker/',
        'add_new_opportunity_tracker': '/modules/crm/opportunities/:pk:/add_new_opportunity_tracker/',
        'lost_reason_update': '/modules/crm/opportunities/:pk:/lost_reason_update/',
        'soft_delete_opportunity': '/modules/crm/opportunities/:pk:/soft_delete_opportunity/',
    },
    'opportunity_activities': {
        'get': '/modules/crm/opportunities/activities/',
        'post': '/modules/crm/opportunities/activities/:pk:/',
    },
    'opportunity_notes': {
        'get': '/modules/crm/opportunities/notes/',
        'post': '/modules/crm/opportunities/notes/:pk:/',
        // 'notes': '/modules/crm/opportunities/schedules/notes/',
        'note_images': '/modules/crm/opportunities/notes/note_images/',
        'get_notes_reply': '/modules/crm/opportunities/notes/:pk:/get_notes_reply/',
        'notes_reply': '/modules/crm/opportunities/notes/:pk:/notes_reply/',
        'update_notes_reply': '/modules/crm/opportunities/notes/:pk:/update_notes_reply/',
        'notes_remove': '/modules/crm/opportunities/notes/:pk:/notes_remove/',
        'get_note_summary': '/modules/crm/opportunities/notes/get_note_summary/',
    },
    'opportunity_schedule': {
        'get': '/modules/crm/opportunities/schedules/',
        'post': '/modules/crm/opportunities/schedules/:pk:/',
        'fetch_email_attachment_files': '/modules/crm/opportunities/schedules/:pk:/fetch_email_attachment_files/',
        'update_schedule': '/modules/crm/opportunities/schedules/:pk:/update_schedule/',
    },
    'opportunity_documents': {
        'get': '/modules/crm/opportunities/documents/',
        'post': '/modules/crm/opportunities/documents/:pk:/',
    },
    'opportunity_pitch_deck': {
        'get': '/modules/crm/opportunities/pitch_deck/',
        'post': '/modules/crm/opportunities/pitch_deck/:pk:/',
        'form_data': '/opportunities/get_form_data/',
        'get_pipeline_stages': '/opportunities/get_pipeline_stages/?pipeline=:pk:',
        'get_fields': '/opportunities/get_field_set/',
        'change_form_view': '/opportunities/change_form_view/',
        'create_custom_field': '/opportunities/create_custom_field/'
    },
    'peoples': {
        'data': '/modules/crm/companies/people/data/',
        'get': '/modules/crm/companies/people/',
        'custom_fields': '/modules/crm/companies/people/custom_fields/',
        'post': '/modules/crm/companies/people/:pk:/',
        // 'searches': '/modules/crm/companies/people/:pk:/contact_els_searches/',
        // 'search': '/modules/crm/companies/people/search/',
    },
    'crm_company': {
        'get': '/modules/crm/companies/',
        'post': '/modules/crm/companies/:pk:/',
        'opportunities': '/modules/crm/companies/:pk:/opportunities/',
        'projects_exist': '/modules/crm/companies/:pk:/projects_exist/',
        'custom_fields': '/modules/crm/companies/custom_fields/',
        'data': '/modules/crm/companies/data/',
        'company_and_person_create':'/modules/crm/companies/company_and_person_create/',
    },
    'formsections': {
        'get': '/modules/crm/opportunities/form-section/',
        'post': '/modules/crm/opportunities/form-section/:pk:/',
        'data': '/modules/crm/opportunities/form-section/data/',
        'reorder': '/modules/crm/opportunities/form-section/reorder/',
    },
    'form_settings': {
        'get': '/modules/crm/opportunities/form_settings/',
        'post': '/modules/crm/opportunities/form_settings/:pk:/',
        'custom_fields_reorder': '/modules/crm/opportunities/form_settings/custom_fields_reorder/',
        'update_layout': '/modules/crm/opportunities/form_settings/update_layout/',
        'custom_fields': '/modules/crm/opportunities/form_settings/custom_fields/',
        'get_form_data': '/modules/crm/opportunities/form_settings/get_form_data/',
        'get_pipeline_stages': '/modules/crm/opportunities/form_settings/get_pipeline_stages/',
        'create_custom_field': '/modules/crm/opportunities/form_settings/create_custom_field/',
        'update_custom_field': '/modules/crm/opportunities/form_settings/update_custom_field/',
        'get_field_set': '/modules/crm/opportunities/form_settings/get_field_set/',
        'get_sectioned_field_set': '/modules/crm/opportunities/form_settings/get_sectioned_field_set/',
        'change_form_view': '/modules/crm/opportunities/form_settings/:pk:/change_form_view/',
        'form_field_settings': '/modules/crm/opportunities/form_settings/form_field_settings/',
        'remove_custom_field': '/modules/crm/opportunities/form_settings/remove_custom_field/',
    },
    'custom_field': {
        'get': '/modules/crm/companies/custom_fields/?category=:pk:',
    },
    'custom_field_categories': {
        'get': '/forms/custom-field-categories/',
        'post': '/forms/custom-field-categories/:pk:/',
    },
    'bespoke_table': {
        'get': '/bespoke_table/',
        'post': '/bespoke_table/:pk:/',
        'import_data': '/bespoke_table/:pk:/import_data/',
    },
    'bespoke_table_column': {
        'get': '/bespoke_table/columns/',
        'post': '/bespoke_table/columns/:pk:/',
        'reorder': '/bespoke_table/columns/reorder/',
        'create_custom_field': '/bespoke_table/columns/create_custom_field/',
        'update_custom_field': '/bespoke_table/columns/update_custom_field/',
        'create_bespoke_table_data': '/bespoke_table/columns/create_bespoke_table_data/',
        'bespoke_table_data': '/bespoke_table/columns/bespoke_table_data/',
        'import_excel_csv_data': '/bespoke_table/columns/import_excel_csv_data/',
        'update_bespoke_table_data': '/bespoke_table/columns/update_bespoke_table_data/',
        'delete_bespoke_table_data': '/bespoke_table/columns/delete_bespoke_table_data/',
        'create_individual_bespoke_table_data': '/bespoke_table/columns/create_individual_bespoke_table_data/',
        'search_bespoke_table_data': '/bespoke_table/columns/search_bespoke_table_data/',
    },
    'bespoke_table_data': {
        'get': '/bespoke_table/data/',
        'post': '/bespoke_table/data/:pk:/',
    },
    'opportunity_tracker':{
        'get': '/modules/crm/opportunities/opportunity_trackers/',
        'get_tracker': '/modules/crm/opportunities/opportunity_trackers/:pk:/',
        'post': '/modules/crm/opportunities/opportunity_trackers/:pk:/',
    },
    'opportunity_trackers_groups':{
        'get': '/modules/crm/opportunities/opportunity_trackers_groups/',
        'post': '/modules/crm/opportunities/opportunity_trackers_groups/:pk:/',
        'add_opportunity': '/modules/crm/opportunities/opportunity_trackers_groups/add_opportunity/',
        'add_opportunity_tracker': '/modules/crm/opportunities/opportunity_trackers_groups/add_opportunity_tracker/',
    },
    'lost_reason': {
        'get': '/modules/crm/opportunities/lost_reason/',
        'post': '/modules/crm/opportunities/lost_reason/:pk:/',
        'reorder': '/modules/crm/opportunities/lost_reason/reorder/',
    },
    'opportunity_status': {
        'get': '/modules/crm/opportunities/opportunity_status/',
        'post': '/modules/crm/opportunities/opportunity_status/:pk:/',
        'reorder': '/modules/crm/opportunities/opportunity_status/reorder/',
    },
    'shareholders':{
        'get':'/organization/shareholders/',
        'post':'/organization/shareholders/:pk:/',
    },
    'financials':{
        'get':'/organization/financials/',
        'post':'/organization/financials/:pk:/',
    },
    'companydblistnames':{
        'get':'/organization/companydblistnames/',
        'post':'/organization/companydblistnames/:pk:/',
    },
    'companydblist':{
        'get':'/organization/companydblist/',
        'post':'/organization/companydblist/:pk:/',
        'remove':'/organization/companydblist/remove/',
    },
    'funding_data':{
        'get':'/organization/funding-data/',
        'post':'/organization/funding-data/:pk:/',
    },
    'extra':{
        'get':'/organization/extra/',
        'post':'/organization/extra/:pk:/',
    },
    'employees':{
        'count': '/organization/employees_count',
        'get':'/organization/employees/',
        'post':'/organization/employees/:pk:/',
    },

    'email':{
        'inbox':'/mailing/email_list/',
    },

    'dac_setup': {
        'get': '/dac/setup/',
        'post': '/dac/setup/:pk:/',
    },

    'dac_submissions': {
        'get': '/dac/submissions/',
        'post': '/dac/submissions/:pk:/',
    },

    'dac_member_comment': {
        'get': '/dac/member-comment/',
        'post': '/dac/member-comment/:pk:/',
    },
    'dac_compliance_comment': {
        'get': '/dac/compliance-comment/',
        'post': '/dac/compliance-comment/:pk:/',
    },
    'maps': {
        'find_address': '/maps/find_address/',
    },
    'ai_company': {
        'get': '/modules/crm/companies/ai/',
        'post': '/modules/crm/companies/ai/:pk:/',
    },
    'form_layout': {
        'get': '/forms/form-layout/',
        'post': '/forms/form-layout/:pk:/',
        'fields': '/forms/form-layout/fields/',
    },
    'form_data_save': {
        'get': '/forms/form-data-save/',
    },
    'form_data_instance': {
        'get': '/forms/form-data-instance/',
    },
    'resource_tabs': {
        'get': '/forms/resource-tabs/',
        'post': '/forms/resource-tabs/:pk:/',
        'reorder': '/forms/resource-tabs/reorder/',
    },
    'resource_tab_layouts': {
        'get': '/forms/resource-tab-layouts/',
        'post': '/forms/resource-tab-layouts/:pk:/',
        'update_positions': '/forms/resource-tab-layouts/update_positions/',
    },

    'tags': {
        'get': '/modules/crm/opportunities/tags/',
        'post': '/modules/crm/opportunities/tags/:pk:/',
    },
    'credentials': {
        'get': '/report/credentials/',
        'post': '/report/credentials/:pk:/', 
        'system_sftp': '/report/credentials/system_sftp/',
    },
    'data_export_schedules':{
        'get': '/report/data_export_schedules/',
        'post': '/report/data_export_schedules/:pk:/',
    },

    'contact_tags': {
        'get': '/contact/tags/',
        'post': '/contact/tags/:pk:/',
    },
};  
